/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebSocketConnection } from '@app/core/services/websocket-connection.service';
import { ClusterId } from '@shared/types/cluster';
import {
  CloudProviderAccount,
  NebulaClusterAccessListRequestBody,
  NebulaClusterAccessListResponseBody,
  NebulaClusterDeploymentRequestBody,
  NebulaClusterDeploymentResponseBody,
  NebulaPrice,
  NebulaRegionList,
  NebulaSubscriptionInfo,
} from '@shared/types/nebula';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NebulaApiService {
  constructor(
    private http: HttpClient,
    private ws: WebSocketConnection,
  ) {}

  getProducts(): Observable<NebulaPrice[]> {
    return this.http.get<NebulaPrice[]>(`/api/v1/nebula/prices`);
  }

  provisionCluster(params: NebulaClusterDeploymentRequestBody): Observable<NebulaClusterDeploymentResponseBody> {
    return this.http.post<NebulaClusterDeploymentResponseBody>(`/api/v1/nebula/deployments`, params);
  }

  getNebulaPlans() {
    return this.ws.getTopic<NebulaSubscriptionInfo>('/user/topic/billing/subscription');
  }

  destroyCluster(clusterId: ClusterId): Observable<void> {
    return this.http.delete<void>(`/api/v1/nebula/deployments/${clusterId}`);
  }

  getCloudProviderRegions(): Observable<NebulaRegionList> {
    return this.http.get<NebulaRegionList>('/api/v1/nebula/regions');
  }

  getAccessList(clusterId: ClusterId): Observable<NebulaClusterAccessListResponseBody> {
    return this.http.get<NebulaClusterAccessListResponseBody>(`/api/v1/nebula/clusters/${clusterId}/access-list`);
  }
  updateAccessList(clusterId: ClusterId, params: NebulaClusterAccessListRequestBody) {
    return this.http.put<void>(`/api/v1/nebula/clusters/${clusterId}/access-list`, params);
  }

  getAccounts() {
    return this.http.get<CloudProviderAccount[]>('/api/v1/nebula/accounts');
  }
}
